export interface SEOItem {
	page: string;
	description: string;
	keywords: string[];
}

const SEO: SEOItem[] = [
	{
		page: "home",
		description:
			"経験豊かなiOSエンジニアで、プログラミングとソフトウェアアーキテクチャに深い知識を有しています。サイバーエージェントで働く岩手県立大学出身のソフトウェアエンジニアで、基礎的なソフトウェア開発の知識と理論を習得しています。",
		keywords: ["伊藤淳一", "iOSエンジニア", "ソフトウェアアーキテクト"],
	},

	{
		page: "about",
		description:
			"サイバーエージェントで働くiOSエンジニアで、アプリケーション開発とソフトウェアアーキテクチャに深い知識と経験を有しています。自分で数々のアプリケーションとツールを開発し、その多くはオープンソースとして公開されています。",
		keywords: ["伊藤淳一", "iOSエンジニア", "ソフトウェアアーキテクト"],
	},

	{
		page: "articles",
		description:
			"技術記事の執筆とカンファレンス登壇実績。iOSDC Japan 2023でのL10nLintに関する発表など、iOS開発に関する知見を共有しています。",
		keywords: ["下村一将", "iOSエンジニア", "技術記事", "登壇", "iOSDC", "L10nLint", "アウトプット"],
	},

	{
		page: "projects",
		description:
			"ローカライズ問題を解決する「L10nLint」、Xcodeのバージョンに対応したプロジェクト開設ツール「xc」、シフト管理アプリ「シフタス」など、さまざまなプロジェクトを手がけてきました。",
		keywords: ["伊藤淳一", "iOSエンジニア", "ソフトウェアアーキテクト", "L10nLint", "xc", "シフタス"],
	},

	{
		page: "services",
		description:
			"個人開発アプリへの広告枠販売など、提供中のサービス一覧。累計20以上のiOSアプリに広告掲載が可能です。",
		keywords: ["広告枠販売", "アプリ広告", "バナー広告", "iOSアプリ", "個人開発"],
	},

	{
		page: "ad-spaces",
		description:
			"リリース済みの個人開発iOSアプリへの広告掲載サービス。月間328万PV以上のアプリポートフォリオで効果的な広告配信が可能です。",
		keywords: ["広告枠販売", "アプリ広告", "バナー広告", "iOSアプリ", "個人開発", "ThreadMaster", "TapShift", "ペアカレ"],
	},

	{
		page: "contact",
		description:
			"新しいアイデアやプロジェクトへの参加に興味があります。何かございましたら、ぜひお気軽にご連絡ください。",
		keywords: ["伊藤淳一", "iOSエンジニア", "ソフトウェアアーキテクト"],
	},
];

export default SEO;
